import { Env } from '../../../core/env';
import { ReviewAction } from '../actions/review_action';
import { ReviewContainer } from '../views/pc/review_container';
import { UserReviewRefineSearchAction } from '../../../core/actions/user_review_refine_search_action/user_review_refine_search_action';
import { ReviewListItemRrAction } from '../actions/review_list_item_rr_action';
import { ReviewButtonAnalytics } from '../../../core/actions/analytics/review_button_analytics';

document.addEventListener('DOMContentLoaded', () => {
  ReviewAction.init(Env, ReviewContainer);
  UserReviewRefineSearchAction.init(Env);
  ReviewListItemRrAction.init(Env);

  (window as any ).ReviewButtonAnalytics = new ReviewButtonAnalytics(ReviewAction);//NOSONAR
});
